import { render, staticRenderFns } from "./Registrazione.vue?vue&type=template&id=caeab5a0&scoped=true&"
import script from "./Registrazione.vue?vue&type=script&lang=js&"
export * from "./Registrazione.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caeab5a0",
  null
  
)

export default component.exports